import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';
import { CommissionShareOrder } from '@models/Commission';
import { snakes } from '@utils/lodash';

export type GetCommissionsParams = PaginationParams;

export class CommissionApi {
  static getAll = async (params = {} as GetCommissionsParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/commissions`, { params: snakes(params) })
      .then((response) => paginate(response) as [CommissionShareOrder[], Pagination]);
  };
}
